var config = require("./config");
var promises = {};
var contexts = {};
var React = require("react");
import _ from "lodash";

let defaultCulture = culture(null);

if (!sessionStorage) {
  var sessionStorage = [];
}
export default defaultCulture;
export const L = defaultCulture.L;
export const getString = defaultCulture.getString;
export const TranslationMixin = defaultCulture.TranslationMixin;

export function culture(cultureName) {
  if (!cultureName) cultureName = config.culture || "sv-SE";

  var caption = function caption(context, key, suffix) {
    if (!context) throw new Error("cannot load caption without context");
    var cacheKey = [cultureName, context].join("\\");
    var resolve = fromCache(cacheKey);

    if (!resolve) {
      resolve = promises[cacheKey] = loadContext(context);
      resolve = resolve.then((r) => (promises[cacheKey]._loaded = r));
    }

    if (key !== undefined) {
      resolve = resolve.then(function (ctx) {
        return ctx.get(key, suffix);
      });
    }

    return resolve;
  };

  caption.emptyContext = {};
  addGetter(caption.emptyContext);

  var loadContext = (caption.loadContext = async function (context) {
    var contextName = (context || "").toLowerCase();
    var cacheKey = [cultureName, context].join("\\").toLowerCase();
    let promise = null;

    promise = fetch(
      config.apiUrl + "v1/translation-strings/" + cultureName + "/" + context,
    ).then((res) => res.json());

    return promise
      .then((strings) => {
        let nw = {};
        Object.keys(strings).forEach(
          (key) => (nw[key.toLowerCase()] = strings[key]),
        );
        return nw;
      })
      .then((data) => {
        sessionStorage[cacheKey] = JSON.stringify(data || "{}");
        return data;
      })
      .then(addGetter)
      .then(addDirect(cacheKey));
  });

  function ReactTag(tag) {
    return class ReactTag extends React.Component {
      componentWillMount() {
        this.forceRefresh(this.props);
      }
      componentWillUnmount() {
        this._dismounted = true;
      }

      componentWillUpdate(nextProps) {
        var nextKey = String(nextProps.caption || nextProps.children);
        var key = String(this.props.caption || this.props.children);
        if (key !== nextKey || nextProps.context !== this.props.context) {
          this.forceRefresh(nextProps);
        }
      }

      forceRefresh(props) {
        var self = this;
        caption(props.context, String(props.caption || props.children)).then(
          function (text) {
            if (props.useDashes) {
              text = "- " + text + " -";
            }
            if (!self._dismounted) {
              self.setState({ text: text });
            }
          },
        );
      }

      render() {
        var props = _.omit(this.props, "caption", "useDashes", "context");
        switch (tag) {
          case "option":
            return (
              <option {...props}>
                {(this.state && this.state.text) || ""}
              </option>
            );
          default:
            return (
              <span {...props}>{(this.state && this.state.text) || ""}</span>
            );
        }
      }
    };
  }
  caption.L = ReactTag("span");
  caption.L.option = ReactTag("option");

  caption.getString = function get(context, key, suffix) {
    let customContext = [cultureName, context].join("\\").toLowerCase();
    return contexts[customContext]
      ? contexts[customContext].get(key, suffix)
      : "";
  };

  caption.TranslationMixin = function TranslationMixin({ contexts }) {
    return function (InnerCls) {
      return class TranslationMixinWrapper extends React.Component {
        async componentWillMount() {
          this.string = this.string.bind(this);
          this.setState({ ready: false });
          let loaded = await Promise.all(contexts.map((c) => loadContext(c)));
          let mapped = _.fromPairs(
            loaded.map((c, i) => [contexts[i].toLowerCase(), c]),
          );
          this.setState({ ready: true, contexts: mapped });
        }

        string(context, key, suffix) {
          var ctx = this.state.contexts;
          var requestContext =
            ctx[String(context).toLowerCase()] || caption.emptyContext;
          return requestContext.get(String(key), suffix);
        }

        render() {
          if (!this.state.ready) return <div>Loading...</div>;
          return <InnerCls {...this.props} L={this.string} />;
        }
      };
    };
  };

  return caption;

  function addGetter(ctx) {
    ctx.get = function (key, suffix) {
      var customKey = key + "_" + config.installationId;
      let smallCustom = customKey.toLowerCase();
      if (ctx[smallCustom]) return ctx[smallCustom] + (suffix || "");
      if (ctx[key.toLowerCase()])
        return ctx[key.toLowerCase()] + (suffix || "");
      return key + "*" + (suffix || "");
    };
    return ctx;
  }

  function addDirect(key) {
    return (ctx) => {
      contexts[key.toLowerCase()] = ctx;
      return ctx;
    };
  }

  function fromCache(cacheKey) {
    if (promises[cacheKey]) return promises[cacheKey];

    if (sessionStorage[cacheKey]) {
      return (promises[cacheKey] = Promise.resolve(
        JSON.parse(sessionStorage[cacheKey]),
      )
        .then(addGetter)
        .then(addDirect(cacheKey)));
    }
  }
}
